import React from 'react';
import InfoPage from '../components/InfoPage';
export default function Contact({ onContactClick }) {
  return <InfoPage title="Contact Us" intro="Questions about KACHNG? We’re here to help.">

    <section className="legal-section"><h2>Get in touch</h2>
      <p>For support, feedback, or privacy questions, send a message using our contact form.</p>
      <button className="info-action" type="button" onClick={onContactClick}>Open Contact Form</button><p>You can also email <a href="mailto:info@kachngco.com">info@kachngco.com</a>.</p>

    </section>
  </InfoPage>;
}
